const weekSpread = ['6%', '7%', '9%', '11%', '14%', '12%', '8%'];

const weekData = [
  [
    weekSpread[0],
    weekSpread[0],
    weekSpread[0],
    weekSpread[0],
    weekSpread[0],
    weekSpread[0],
    weekSpread[0]
  ],
  [
    weekSpread[1],
    weekSpread[1],
    weekSpread[1],
    weekSpread[1],
    weekSpread[1],
    weekSpread[1],
    weekSpread[1]
  ],
  [
    weekSpread[2],
    weekSpread[2],
    weekSpread[2],
    weekSpread[2],
    weekSpread[2],
    weekSpread[2],
    weekSpread[2]
  ],
  [
    weekSpread[3],
    weekSpread[3],
    weekSpread[3],
    weekSpread[3],
    weekSpread[3],
    weekSpread[3],
    weekSpread[3]
  ],
  [
    weekSpread[4],
    weekSpread[4],
    weekSpread[4],
    weekSpread[4],
    weekSpread[4],
    weekSpread[4],
    weekSpread[4]
  ],
  [
    weekSpread[5],
    weekSpread[5],
    weekSpread[5],
    weekSpread[5],
    weekSpread[5],
    weekSpread[5],
    weekSpread[5]
  ],
  [
    weekSpread[6],
    weekSpread[6],
    weekSpread[6],
    weekSpread[6],
    weekSpread[6],
    weekSpread[6],
    weekSpread[6]
  ]
];

export const chartConfig = [
  {
    type: 'month',
    height: '40%',
    weeks: weekData
  },
  {
    type: 'month',
    height: '52%',
    weeks: weekData
  },
  {
    type: 'month',
    height: '64%',
    weeks: weekData
  },
  {
    type: 'month',
    height: '76%',
    weeks: weekData
  },
  {
    type: 'month',
    height: '88%',
    weeks: weekData
  },
  {
    type: 'month',
    height: '100%',
    weeks: weekData
  }
];
